<template>
    <div class="delivery-route-config-rules" v-if="drivers && trucks">
        <h3>Automatische ritten</h3>
        <template v-if="value" v-for="(item, itemIndex) in value">
            <delivery-route-config-form
                :key="'configRule.' + itemIndex"
                v-model="value[itemIndex]"
                v-if="!item.removed"
                :trucks="trucks"
                :drivers="drivers">
                <ui5-button>
                    <i @click="item.removed = true" class="fa fa-trash"></i>
                </ui5-button>
            </delivery-route-config-form>
        </template>
        <h4>Toevoegen</h4>
        <delivery-route-config-form
            v-if="newItem"
            v-model="newItem"
            :trucks="trucks"
            :drivers="drivers">
            <ui5-button @click="addNewItem">+</ui5-button>
        </delivery-route-config-form>
    </div>
</template>
<script>
import deliveryDatesApi from '../../api/deliveryDates';
import DeliveryRouteConfigForm from './DeliveryRouteConfigForm';
export default {
    name: 'DeliveryRouteConfigRules',
    components: { DeliveryRouteConfigForm },
    props: ['value'],
    methods: {
        createNewItem() {
            this.newItem = {
                id: null,
                count: 1,
                day: 1,
                driverId: this.drivers[0].ID,
                truckId: this.trucks[0].ID,
                removed: false,
            };
        },
        addNewItem() {
            this.value.push(this.newItem);
            this.createNewItem();
        },
    },
    data() {
        return {
            newItem: null,
            drivers: null,
            trucks: null,
        };
    },
    watch: {
        value() {
            this.$emit('input', this.value);
        },
    },
    mounted() {
        const p1 = deliveryDatesApi.listTrucks().then((response) => {
            this.trucks = response.data.data;
        });
        const p2 = deliveryDatesApi.listDrivers().then((response) => {
            this.drivers = response.data.data;
        });

        Promise.all([p1, p2]).then(() => {
            this.createNewItem();
        });
    },
};
</script>
